export const LOADABLE_SHARED = {
  initialChunks: {}
};
